import { Box } from "../../../../ui/box";
import { Text } from "../../../../ui/text";

/**
 * One line saying what the flow is doing — and announcing it. A polite live region,
 * so a person who cannot watch cards appear still hears "Generando conceptos… 2 de 3",
 * "Escribiendo el guion…", "El guion está listo".
 *
 * The region stays mounted when there is nothing to say: screen readers announce
 * changes to a live region that already exists, and often say nothing for one that
 * appears with its text already in it.
 */
const StageCaption = ({ caption }: { caption: string | null }) => (
  <Box
    accessibilityLiveRegion="polite"
    className={caption ? "mb-3 ml-[30px]" : ""}
  >
    {caption ? (
      <Text className="text-xs text-typography-500">{caption}</Text>
    ) : null}
  </Box>
);

export default StageCaption;
